import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
import { MapSubtopicOne } from "../../objects/Tema4/subtopicOne/MapSubtopicOne";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { Cpu } from "./cpu";
import { Escaner } from "./escaner";
import { Teclado } from "./teclado";
import { PinPad } from "./pinPad";
import { Paneles_mostrador } from "./paneles_s2a1";
import { PanelesTeclado } from "./paneles_s2a2";

export class SceneTopicTwo extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviroment) {
		super();
		this.camera = new CameraController();
		this.environment = enviroment;
		this.characterSelected = character;
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.create();
		this.light();
		// this.helper();
		this.renderAnimations();
		this.observerListeners();
	}
	create() {
		this.add(this.characterSelected);

		this.mapmenu = new MapSubtopicOne(this.loadingManager);
		this.add(this.mapmenu);

		this.cpu = new Cpu(this.loadingManager);
		this.cpu.visible = false
		this.add(this.cpu)

		this.escaner = new Escaner(this.loadingManager);
		this.escaner.visible = false
		this.add(this.escaner)

		this.teclado = new Teclado(this.loadingManager);
		this.teclado.visible = false
		this.add(this.teclado)

		this.pinPad = new PinPad(this.loadingManager);
		this.pinPad.visible = false
		this.add(this.pinPad)

		this.paneles = new Paneles_mostrador(this.loadingManager)
		this.add(this.paneles)

		this.panelesTeclado = new PanelesTeclado(this.loadingManager)
		this.add(this.panelesTeclado)
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
					// ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityOne.hideModels)
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
				});
				break;

			default:
				// posicion escritorio 1
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	observerListeners() {
		// PosicionSobreEscritorio
		ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityOne.moveCameraOverDesk, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-11.4182, -0.718, -1.2509), 1, new Vector3(-10.535, -1.03, -1.61), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 2;

				this.characterSelected.visible = false
			});
		})
		// PosicionAmpliadaEscritorio
		ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityOne.amplifyDesk, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.7635, 0.0562, -0.6919), 1, new Vector3(-11.867, -0.357, -1.423), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityOne.showModels, () => {
			this.cpu.visible = true
			this.cpu.onAnimateCpu()
			this.escaner.visible = true
			this.escaner.onAnimateScaner()
			this.teclado.visible = true
			this.teclado.onAnimateKeyboard()
			this.pinPad.visible = true
			this.pinPad.onAnimatePinPad()
			// Monitor
			// this.mapmenu.helpersChild()
			this.mapmenu.onAnimate(this.mapmenu.Pantalla)

			this.mouseListenersActivityOne()
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityOne.hideModels, () => {
			this.cpu.visible = false
			this.cpu.clearAnimation()
			this.escaner.visible = false
			this.escaner.clearAnimation()
			this.teclado.visible = false
			this.teclado.clearAnimation()
			this.pinPad.visible = false
			this.pinPad.clearAnimation()
			this.mapmenu.clearAnimation()
			this.paneles.Cpu.visible = false
			this.paneles.Escaner.visible = false
			this.paneles.Pantalla.visible = false
			this.paneles.PinPad.visible = false
			this.paneles.Teclado.visible = false
			this.paneles.visible = true
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityTwo.moveCameraOverKeyboard, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			// this.camera.moveCameraToPoint(new Vector3(-11.7713, -0.2365, -1.4382), 1, new Vector3(-10.836, -1.05, -1.818), () => {
			this.camera.moveCameraToPoint(new Vector3(-11.4107, -0.4871, -1.8407), 1, new Vector3(-11.132, -1.237, -1.84), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 0.75;
				this.camera.control.maxDistance = 1.1;
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityTwo.showKeyboard, () => {
			this.teclado.position.set(-11.2224, -0.99, -1.8533)
			this.teclado.visible = true
			this.teclado.onAnimateKeys()
			this.panelesTeclado.visible = true
			// this.panelesTeclado.helpersChild()
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.teclado.A,
				this.teclado.S,
				this.teclado.F,
				this.teclado.T,
				this.teclado.F6,
				this.teclado.F8,
				this.teclado.Servicio,
				this.teclado.RepetirArticulo,
				this.teclado.Borrar,
			];

			this.mouseListenersActivityTwo()
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityTwo.hideKeyboard, () => {
			this.teclado.visible = false
			this.panelesTeclado.visible = false
			this.panelesTeclado.hidePanels()
		})
	}

	mouseListenersActivityOne() {
		let touchCPU = false
		let touchEscaner = false
		let touchTeclado = false
		let touchPinPad = false
		let touchPantalla = false

		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name
				const parentName = interactions[0].object.parent.name
				// console.log(name, parentName);

				//CPU
				if (name === 'CPU') {
					this.paneles.Cpu.visible = true
					this.cpu.clearAnimation()
					touchCPU = true
				}
				//Escaner
				if (name === 'Escaner') {
					this.paneles.Escaner.visible = true
					this.escaner.clearAnimation()
					touchEscaner = true
				}
				//Teclado
				if (name === 'Teclado' || parentName === 'Teclado') {
					this.paneles.Teclado.visible = true
					this.teclado.clearAnimation()
					touchTeclado = true
				}
				//PinPad
				if (name === 'Cube004') {
					this.paneles.PinPad.visible = true
					this.pinPad.clearAnimation()
					touchPinPad = true
				}
				//Monitor
				if (name === 'Pantallas_2') {
					this.paneles.Pantalla.visible = true
					this.mapmenu.clearAnimation()
					touchPantalla = true
				}
			}
			if (
				touchCPU === true &&
				touchEscaner === true &&
				touchTeclado === true &&
				touchPinPad === true &&
				touchPantalla === true
			) {
				setTimeout(() => {
					this.paneles.visible = false
					this.cpu.visible = false
					this.escaner.visible = false
					this.teclado.visible = false
					this.pinPad.visible = false
					this.returnToDesk()
					ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityOne.finishActivity)
				}, 1200);
			}

			// console.log(touchCPU, touchEscaner, touchTeclado, touchPinPad, touchPantalla);

		});
	}
	mouseListenersActivityTwo() {
		let touchKey_A = false
		let touchKey_S = false
		let touchKey_F = false
		let touchKey_T = false
		let touchKey_F6 = false
		let touchKey_F8 = false
		let touchKey_Servicio = false
		let touchKey_RepetirArticulo = false
		let touchKey_Borrar = false

		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name
				switch (name) {
					// Tecla A
					case 'Cube007':
						this.teclado.clearKeyAnimation(this.teclado.A)
						this.panelesTeclado.showSelectedPanel('A')
						touchKey_A = true
						break;
					// Tecla S
					case 'Cube032':
						this.teclado.clearKeyAnimation(this.teclado.S)
						this.panelesTeclado.showSelectedPanel('S')
						touchKey_S = true
						break;
					// Tecla F
					case 'Cube088':
						this.teclado.clearKeyAnimation(this.teclado.F)
						this.panelesTeclado.showSelectedPanel('F')
						touchKey_F = true
						break;
					// Tecla T
					case 'Cube024':
						this.teclado.clearKeyAnimation(this.teclado.T)
						this.panelesTeclado.showSelectedPanel('T')
						touchKey_T = true
						break;
					// Tecla F6
					case 'Cube062':
						this.teclado.clearKeyAnimation(this.teclado.F6)
						this.panelesTeclado.showSelectedPanel('F6')
						touchKey_F6 = true
						break;
					// Tecla F8
					case 'Cube064':
						this.teclado.clearKeyAnimation(this.teclado.F8)
						this.panelesTeclado.showSelectedPanel('F8')
						touchKey_F8 = true
						break;
					// Tecla Servicios
					case 'Cube057':
						this.teclado.clearKeyAnimation(this.teclado.Servicio)
						this.panelesTeclado.showSelectedPanel('Service')
						touchKey_Servicio = true
						break;
					// Tecla Repetir Articulo
					case 'Cube006':
						this.teclado.clearKeyAnimation(this.teclado.RepetirArticulo)
						this.panelesTeclado.showSelectedPanel('RepetirArticulo')
						touchKey_RepetirArticulo = true
						break;
					// Tecla Borrar
					case 'Cube030':
						this.teclado.clearKeyAnimation(this.teclado.Borrar)
						this.panelesTeclado.showSelectedPanel('Borrar')
						touchKey_Borrar = true
						break;
					default:
						break;
				}
			}
			if (
				touchKey_A === true &&
				touchKey_S === true &&
				touchKey_F === true &&
				touchKey_T === true &&
				touchKey_F6 === true &&
				touchKey_F8 === true &&
				touchKey_Servicio === true &&
				touchKey_RepetirArticulo === true &&
				touchKey_Borrar === true
			) {
				setTimeout(() => {
					this.teclado.visible = false
					this.panelesTeclado.visible = false
					this.returnToDesk()
					ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityTwo.showSecondDialog)
				}, 2000);
			}
		});
	}
	returnToDesk() {
		this.camera.control.maxAzimuthAngle = Infinity;
		this.camera.control.minAzimuthAngle = Infinity;
		this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
			this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
			this.camera.control.minPolarAngle = MathUtils.degToRad(20);

			this.characterSelected.visible = true
		});
	}
	renderAnimations(delta) {
		//animaciones
	}
}